import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import PasswordInput from 'components/field/PasswordInput';
import StringInput from 'components/field/StringInput';
import FormItem from 'components/form/FormItem';

const StoreCredentials = (props) => {
	const { salesChannel } = useSelector((state) => state.salesChannel);
	const { t } = useTranslation();
	return (
		<>
			<FormItem label={`${salesChannel?.slug}.username`} {...props}>
				<StringInput
					name="username"
					placeholder={t('fieldPlaceholder', { name: t(`${salesChannel?.slug}.username`) })}
				/>
			</FormItem>
			<FormItem label={`${salesChannel?.slug}.password`} {...props}>
				<PasswordInput
					name="password"
					placeholder={t('fieldPlaceholder', { name: t(`${salesChannel?.slug}.password`) })}
				/>
			</FormItem>
		</>
	);
};

export default StoreCredentials;
